<template>
  <div>
    <app-header />
    <router-view/>
  </div>
</template>
<style lang="less">
  @import '../../less/common';
  @import '../../less/admin';

  body { background:#fff; }
  [header] + div { .w(1200); .mt(20); .mh-c; }
</style>

<script>
import AppHeader from './common/AppHeader.vue';

export default {
  components: { AppHeader },
  mounted() {
    document.title = this.asset('name');
  },
};
</script>



// WEBPACK FOOTER //
// src/views/judge/template.vue